import { useQuery } from '@tanstack/react-query';
import { fetchUserRoles } from '../services/userRbac';
import { userKeys } from './useUsersQuery';
import type { UserRole } from '../types/users.types';

export const useUserRolesQuery = (id: string) => {
    return useQuery<UserRole[]>({
        queryKey: userKeys.roles(id),
        queryFn: () => fetchUserRoles(id),
        enabled: !!id,
        staleTime: 5 * 60 * 1000,
        gcTime: 10 * 60 * 1000,
    });
};
